import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { RecordProvider } from './contexts/record-context'
import { SettingProvider } from './contexts/setting-context'
import './globals.css'

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SettingProvider>
      <RecordProvider>
        <App />
      </RecordProvider>
    </SettingProvider>
  </React.StrictMode>
)
